import { cn } from '@/lib/utils';

interface InlineToastProps {
  label?: string;
}

export const InlineSuccessToast = ({ label = 'Success' }: InlineToastProps) => {
  return (
    <span
      className={cn(
        'sm:mt-0 sm:ml-2 text-xs rounded px-2 py-1',
        'bg-status-success-background text-status-success-emphasis border border-status-success-border',
        'transition-colors duration-200',
        'max-w-full'
      )}
      role="status"
    >
      {label}
    </span>
  );
};

export const InlineErrorToast = ({ label = 'Error' }: InlineToastProps) => {
  return (
    <span
      className={cn(
        'sm:mt-0 sm:ml-2 text-xs rounded px-2 py-1 box-border',
        'bg-destructive/20 text-destructive-foreground border border-destructive',
        'transition-colors duration-200',
        'max-w-full'
      )}
      role="alert"
    >
      {label}
    </span>
  );
};
